// extracted by mini-css-extract-plugin
export var modal = "_ik-0";